import { TableRow } from "@material-ui/core";
import React from "react";
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.data;
        const dayCount = this.props.daysCount;
        const allTotal = this.props.allTotal;
        const totalArray = this.props.totalArray;
        const startDay = this.props.startDay;

        return (
            <div>
                <h3><center><u>Daily Field Performance Report</u></center></h3>
                <div className="row pl-2 pb-2 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                </div>
                <div className="row pl-2 pb-2 pt-2">
                    <div className="col"><b>Division: </b>{searchData.division} </div>
                    <div className="col"><b>From: </b> {searchData.month}</div>
                </div>
                <div>
                    <TableContainer component={Paper}>
                        <>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Field Name</TableCell>

                                        {dayCount.map((count, i) => (
                                            <TableCell key={i} align="center" style={{ fontWeight: "bold" }}>{count}</TableCell>
                                        ))}

                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Total</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="center" style={{ fontWeight: "bold" }}>  </TableCell>

                                        {startDay.map((count, i) => (
                                            <TableCell key={i} align="center" style={{ fontWeight: "bold" }}>{count}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.map((rows, i) => (
                                        <TableRow key={i} >
                                            <TableCell component="th" scope="row" align="center"> {rows.fieldName}</TableCell>
                                            {dayCount.map((count) => {
                                                const result = rows[count]

                                                if (result == undefined) {
                                                    return (
                                                        <TableCell component="th" scope="row" align="center"> - </TableCell>
                                                    );
                                                }
                                                else {
                                                    return (
                                                        <TableCell component="th" scope="row" align="center" style={{ backgroundColor: "#1de9b6" }}> {parseFloat(result).toFixed(2)}</TableCell>
                                                    );
                                                }
                                            })}
                                            <TableCell component="th" scope="row" style={{ backgroundColor: "#14a37f" }} align="center"> {parseFloat(rows.amount).toFixed(2)}</TableCell>
                                        </TableRow>
                                    ))}
                                    <TableRow>
                                        <TableCell component="th" style={{ fontWeight: "bold" }} scope="row" align="center"> Total</TableCell>
                                        {dayCount.map((count) => {
                                            const result = totalArray.find(x => x.name == count)

                                            if (result == undefined) {
                                                return (
                                                    <TableCell component="th" style={{ fontWeight: "bold" }} scope="row" align="center"> - </TableCell>
                                                );
                                            }
                                            else {
                                                return (
                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold", backgroundColor: "#14a37f" }}> {parseFloat(result.value).toFixed(2)}</TableCell>
                                                );
                                            }
                                        })}
                                        <TableCell component="th" scope="row" style={{ fontWeight: "bold" }} align="center"> {parseFloat(allTotal).toFixed(2)}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </>
                    </TableContainer>
                </div>

            </div >
        );
    }
}